import axios from 'axios';
import { getToken } from '../utils/auth';

const baseURL = process.env.REACT_APP_N8N_API_URL || 'https://n8n.uniapp.vn/webhook';

const axiosClient = axios.create({ baseURL });

const handleResponse = (res) => res.data;
const handleError = (err) => Promise.reject(err);

axiosClient.interceptors.request.use(
  (req) => {
    const token = getToken();
    if (token) req.headers.Authorization = `Bearer ${token}`;
    return req;
  },
  (err) => Promise.reject(err)
);

axiosClient.interceptors.response.use(handleResponse, handleError);

export default axiosClient;
